import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ps-2" }
const _hoisted_2 = { class: "row d-flex" }



  // Types
  import { BookingSummary } from '@/services/BookingService.interface'

  // Components
  import PastBooking from './PastBooking.vue'
  import PageSection from '../UI/PageSection.vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  interface Props {
    bookings: BookingSummary[]
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PastBookingsList',
  props: {
    bookings: {}
  },
  setup(__props: any) {

  const { t } = useI18n()

  const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageSection, {
      title: _unref(t)('reservations.pastBookings')
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.bookings, (booking) => {
            return (_openBlock(), _createBlock(PastBooking, {
              booking: booking,
              key: `${booking.liheId}-${booking.departureDate}`
            }, null, 8, ["booking"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["title"])
  ]))
}
}

})